// Configuração do EmailJS
export const EMAIL_CONFIG = {
 
  SERVICE_ID: 'service_4718cpi', 
  TEMPLATE_ID: 'template_d9wj4j9',
  PUBLIC_KEY: 'CEP96huntQFGFQemg', 
  TO_EMAIL: 'edfran.105@gmail.com'
};

// Template de email formatado
export const EMAIL_TEMPLATE = {
  to_email: 'edfran.105@gmail.com',
  from_name: '{{user_name}}',
  from_email: '{{user_email}}',
  phone: '{{user_phone}}',
  device: '{{selected_device}}',
  message: '{{user_message}}',
  subject: 'Nova Solicitação de Orçamento - Site GPS Tracking'
};
